module.exports = __webpack_public_path__ + "static/img/shezhi_caijin.b73b9761.png";